import React, { useEffect, useState } from "react";
import { PremiumLoader } from "./PremiumLoading";

// Mounted once at the app root (App.js), regardless of auth state. If the
// local backend crashes mid-session and main.js auto-restarts it
// (handleMidSessionCrash), this blocks the UI with an explicit "reconnecting"
// message instead of leaving forms clickable while requests silently fail
// with a raw connection-refused error indistinguishable from a real network
// problem (see describeFetchError in Log_interface.jsx). No-op on the web
// build — window.posDesktop only exists inside the Electron renderer.
function BackendReconnectOverlay() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!window.posDesktop?.isDesktop || !window.posDesktop?.onBackendStatus) return undefined;
    return window.posDesktop.onBackendStatus((next) => {
      setStatus(next?.state === "restored" ? null : next);
    });
  }, []);

  if (!status || status.state === "restored") return null;

  const title = status.state === "failed" ? "Connection Lost" : "Reconnecting";
  const subtitle =
    status.state === "failed"
      ? "The local OverPOS service stopped and could not be restarted. The app will close shortly."
      : `The local OverPOS service is restarting${status.attempt ? ` (attempt ${status.attempt}/${status.maxAttempts})` : ""}. Please wait — this is usually quick.`;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <PremiumLoader tone="auth" compact title={title} subtitle={subtitle} className="max-w-[420px]" />
    </div>
  );
}

export default BackendReconnectOverlay;
